exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pie{margin:20px}.pie text{font-family:Verdana;fill:#888}.pie .name-text{font-size:1em}.pie .value-text{font-size:3em}", ""]);

// exports
